<template>
	<div class="drawer-container" v-if="visible">
		<div class="drawer-white" @click="closeDrawer"></div>
		<div class="drawer-wrap">
			<div class="drawer-title" v-if="title">
				{{ title }}
				<slot name="cancel"></slot>
			</div>
			<div class="drawer-content">
				<slot></slot>
			</div>
			<slot name="footer"></slot>
		</div>
	</div>
</template>
<script>
export default {
	name: 'Drawer',
	props: {
		visible: {
			type: Boolean,
			default: false,
		},
		title: {
			type: String,
			default: '',
		},
		drawClose: {
			type: Boolean,
			default: true,
		}
	},
	methods: {
		closeDrawer() {
			if (this.drawClose) {
				this.$emit('close')
			}
		},
	},
}
</script>
<style scoped>
.drawer-container {
	position: fixed;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.45);
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	z-index: 3;
  font-family: PingFang SC;
}
.drawer-white {
	flex: 1;
}
.drawer-wrap {
	max-height: 73vh;
	border-radius: 0.4267rem 0.4267rem 0 0;
	background: rgba(255, 255, 255, 1);
	/* padding: 0 0.64rem; */
	display: flex;
	flex-direction: column;
}
.drawer-title {
	font-size: 0.48rem;
	font-weight: 500;
	line-height: 0.7467rem;
	letter-spacing: 0px;
	text-align: center;
	padding: 0.3773rem 0;
	position: relative;
}
.drawer-content {
	flex: 1;
	overflow-y: auto;
	padding: 0 0.64rem;
}
.drawer-footer{
	padding: 0.32 0.64rem;
}
</style>
